import React, { VFC } from 'react';
import { ColumnInstance, FilterValue, IdType, Row } from 'react-table';
import { INQUIRY_TYPES } from '../../../../../re-ducks/makerContacts/types';

export const inquiryTypeFilter = (
  rows: Array<Row<any>>,
  columnIds: Array<IdType<any>>,
  filterValue: FilterValue,
): Array<Row<any>> => {
  return rows.filter((row) => {
    return filterValue ? row.values[columnIds[0]] === filterValue : true;
  });
};

export const InquiryTypeFilter: VFC<{ column: ColumnInstance<never> }> = ({
  column,
}) => {
  const { id, render, setFilter, filterValue } = column;

  return (
    <div>
      <div className="label">{render('Header')}</div>
      <div className="control select is-block">
        <select
          className="select column is-full"
          name={id}
          value={filterValue || ''}
          onChange={(event) => setFilter(event.target.value || '')}
        >
          <option value="">選択してくだい</option>
          {INQUIRY_TYPES.map((label) => (
            <option key={label} value={label}>
              {label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
